import { Fragment } from "react";
import Moment from "react-moment";
import ShipmentNavigateButton from "./Shipment_Navigate";
import { Table } from "react-bootstrap";

const DataOne = ({
  data,
  setSelectedShipment,
  currentPage,
  setCurrentPage,
  totalShipments,
}) => {
  const render = (res) => {
    switch (res) {
      case "Pending Pickup":
        return "Pending Pickup";
      case "Cancelled":
        return "Cancelled";
      case "Rejected":
        return "Rejected";
      case "Delivered":
        return "Delivered";
      case "Pending Approval":
        return "Pending Approval";

      default:
        return "Delivered";
    }
  };

  const renderColor = (res) => {
    switch (res) {
      case "Pending Pickup":
        return "pending-pickup";
      case "Cancelled":
        return "cancel";
      case "Rejected":
        return "cancel";
      case "Delivered":
        return "success";
      case "Pending Approval":
        return "pending";

      default:
        return "success";
    }
  };

  return (
    <Fragment>
      <table className="d-none d-md-table">
        <thead>
          <th>RECEIVER</th>
          <th>AMOUNT</th>
          <th>STATUS</th>
          <th>STATUS</th>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr onClick={() => setSelectedShipment(item)}>
              <td>
                <div className="Box">
                  <h5>{item.receiver_name}</h5>
                  <p>{item.receiver_phone_no}</p>
                  <p className="truncate-text">{item.receiver_address_1}</p>
                </div>
              </td>
              <td>
                <div className="Box">
                  <h5>
                    &#8358;
                    {parseFloat(item.total_amount).toLocaleString("en-US")}
                  </h5>
                  {/* <p><Moment format="h:mm a">{item.date_time}</Moment></p> */}
                </div>
              </td>
              <td>
                <div className="Box">
                  <div className={`Btn ${renderColor(item.status)}`}>
                    {render(item.status)}
                  </div>
                </div>
              </td>
              <td>
                <div className="Box">
                  <h5>
                    <Moment format="DD MMM YYYY">{item.date_time}</Moment>
                  </h5>
                  <p>
                    <Moment format="h:mm a">{item.date_time}</Moment>
                  </p>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Table responsive className="d-md-none">
        <thead>
          <th>RECEIVER</th>
          <th>AMOUNT</th>
          <th>DATE</th>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr onClick={() => setSelectedShipment(item)}>
              <td>
                <div className="Box">
                  <h5 style={{ whiteSpace: "nowrap" }}>{item.receiver_name}</h5>
                  <p>{item.receiver_phone_no}</p>
                  <p className="truncate-text">{item.receiver_address_1}</p>
                </div>
              </td>
              <td>
                <div className="Box">
                  <h5>
                    &#8358;
                    {parseFloat(item.total_amount).toLocaleString("en-US")}
                  </h5>
                  {/* <p><Moment format="h:mm a">{item.date_time}</Moment></p> */}
                </div>
                <div className="Box">
                  <div className={`Btn ${renderColor(item.status)}`}>
                    {render(item.status)}
                  </div>
                </div>
              </td>
              <td>
                <div className="Box">
                  <h5 style={{ whiteSpace: "nowrap" }}>
                    <Moment format="DD MMM YYYY">{item.date_time}</Moment>
                  </h5>
                  <p>
                    <Moment format="h:mm a">{item.date_time}</Moment>
                  </p>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <ShipmentNavigateButton
        CurrentPage={currentPage}
        setCurrentPage={setCurrentPage}
        output={totalShipments}
      />
    </Fragment>
  );
};

export default DataOne;
